import { Injectable } from '@angular/core';
import { Observable, Subscriber, observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { io, Socket } from 'socket.io-client';
import { NotificationService } from '../notification.service';
import { ShareService } from '../share.service';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  private readonly globalMessageCountStorageKey = 'global_message_count';
  private readonly individualUnreadMessageCountStorageKey = 'individual_unread_messages_count';
  private readonly groupUnreadMessageCountStorageKey = 'group_unread_messages_count';
  private readonly favouriteUnreadMessageCountStorageKey = 'favourite_user_unread_messages_count';

  sockets: any = null;
  notifSocket: any = null;

  Socket_endpoint;
  APIEndpoint;
  room_id = '';
  receive_message_view = [];
  receiveStatus = [];
  receive_request_: any;
  user_id: string = '';
  video_status: any = []
  timerInterval: any;
  userId: any;

  constructor(private https: HttpClient, private ns: NotificationService, private shareService: ShareService) {
    this.user_id = localStorage.getItem('user_id')
    this.Socket_endpoint = environment.socket_EndPoint;
    this.APIEndpoint = environment.APIEndpoint;
  }

  connection() {
    this.user_id = localStorage.getItem('user_id');
    if (!this.user_id) return;

    // Disconnect if already connected
    // this.close_socket();

     // Check if socket is already connected
      if (this.sockets && this.sockets.connected) {
        return;  // Avoid reconnecting if socket is already connected
      }

    if(!this.sockets || !this.sockets.connected) {
      // Main socket
      this.sockets = io(this.Socket_endpoint, {
        transports: ['websocket'],
        reconnection: true,
        reconnectionAttempts: 5, // max attempts
        reconnectionDelay: 2000,
      });
  
      // When connected, emit user_id
      this.sockets.on('connect', () => {
        this.sockets.emit('connection', { user_id: this.user_id });
        this.registerMainListeners();
      });
    }

    if (!this.notifSocket || !this.notifSocket.connected) {
      // Notif socket
      this.notifSocket = io(this.Socket_endpoint + "/notifs", {
        transports: ['websocket'],
        reconnection: true,
        reconnectionAttempts: 5, // max attempts
        reconnectionDelay: 2000,
      });

      // When connected, emit user_id
      this.notifSocket.on('connect', () => {
        // Register notif listeners
        this.registerNotifListeners();
      });
    }





    // Code will be remove in future after testing 
    // if (this.sockets.disconnected) {
    //   this.Socket_endpoint = environment.socket_EndPoint;
    //   this.sockets = io(this.Socket_endpoint);
    //   this.receive_message();
    //   this.get_user_status();
    // }
    // let user_id = localStorage.getItem('user_id')
    // this.sockets.emit('connection', {
    //   'user_id': user_id
    // });

  }


  /** Call this on logout */
  close_socket() {
    if (this.sockets && this.sockets.connected) {
      this.sockets.removeAllListeners();
      this.sockets.disconnect();
      this.sockets = null;
            console.log('Main socket closed status:', this.sockets);
    } else{
      // Log the status of the main socket
      console.log('Main socket not closed status:', this.sockets);
    }
    if (this.notifSocket && this.notifSocket.connected) {
      this.notifSocket.removeAllListeners();
      this.notifSocket.disconnect();
      this.notifSocket = null;
       console.log('Notify socket closed status:', this.notifSocket);

    } else{
      // Log the status of the notif socket
      console.log('Notify socket not closed status:', this.notifSocket);
    }
  }

  // Register main socket listeners
  private registerMainListeners() {
    if (!this.sockets) return;
    // Register all  main socket listeners here
    this.receive_message();
    this.listenGlobalMessageCount();
    this.receiveLiveSession();
    this.get_user_status();
    this.get_refresh_status();
    this.receiveLiveSessionForadmin();
  }

  // Register notif socket listeners
  private registerNotifListeners() {
    if (!this.notifSocket) return;
    // Register all your notif socket listeners here
    this.receive_permission();
  }


  send_request(user_id, name) {
    if (!this.notifSocket) return;
    let sender_id = localStorage.getItem('user_id')
    this.notifSocket.emit('send_permission', {
      sender: sender_id,
      receiver: user_id
    });
  }

  Accept_decline(sent_to, sent_by, answer): Observable<any> {
    let body = {
      'sent_by': sent_by,
      'sent_to': sent_to,
      'answer': answer
    }
    return this.https.post<any>(this.Socket_endpoint + '/chat/request', body);
  }

  view_room(room_id): Observable<any> {
    let params = new HttpParams();
    params = params.append('room_id', room_id);
    return this.https.get<any>(this.Socket_endpoint + '/chat/room', { params });
  }

  join_room(username, room_id) {
    if (!this.sockets) return;
    this.sockets.emit('join_room', {
      username: username,
      room: room_id
    });
  }


  send_message(username, room_id, message, files?: String[]) {
    let room = room_id
    this.room_id = room_id;
    if (files && files.length > 0) {
      message = null;
    } else {
      files = null
    }
    if (!this.sockets) return;
    localStorage.setItem('room_id', room_id);
    this.sockets.emit('send_message', {
      "username": username,
      "room": room,
      "message": message,
      'resource_ids': files,
      'type': 'web'
    });

  }

  receive_message() {
    if (!this.sockets) return;
    this.user_id = localStorage.getItem('user_id')
    this.sockets.on('receive_message', (data) => {
      if (data && data.receivers.length > 0) {
        let isHasUser = data.receivers.filter((userId) => {
          if (userId == this.user_id || data.user_id == this.user_id) {
            return true;
          }
        })

        if (isHasUser.length > 0) {
          this.receive_message_view.push(data);
        }
      }
    });
  }


  // emit online status
  refresh_status(refresh_member_ids) {
    if (!this.sockets) return;
    this.sockets.emit('refresh_chat', { "receivers": refresh_member_ids });
  }


  get_refresh_status(): Observable<any> {
    return new Observable<any>((observer) => {
      if (!this.sockets) return;
      this.sockets.on('refresh_chat_status', (data) => {
        observer.next(data);
      })
    })
  }


  get_notification_data(): Observable<any> {
    return new Observable<any>((observer) => {
      if (!this.sockets) return;
      this.sockets.on('global_notifications', (data) => {
        observer.next(data);
      })
    })
  }




  // emit online status
  set_user_status(chat_status, user_id) {
    if (!this.sockets) return;
    this.sockets.emit('set_user_status', { "chat_status": chat_status, "user_id": user_id });
  }

  // listen for online status updates
  get_user_status(): Observable<any> {
    return new Observable<any>((observer) => {
      if (!this.sockets) return;
      this.sockets.on('current_user_status', (data) => {
        observer.next(data);
      })
    })
  }

  receive_permission(): Observable<any> {
    return new Observable<any>((observer) => {
      if (!this.notifSocket) return;
      this.notifSocket.on('receive_permission', (data) => {
        observer.next(data);
      })
    })
  }

  // close_socket() {
  //   this.sockets.disconnect();
  // }

  create_group(user_info, group_name, group_icon): Observable<any> {
    let body = {
      'members': user_info,
      'name': group_name,
      'group_description': '',
      'sub_heading': '',
      'avatar_url': group_icon
    }
    return this.https.post<any>(this.Socket_endpoint + '/chat/create-group', body);
  }


  get_group_info(room_id): Observable<any> {
    let params = new HttpParams();
    params = params.append('room_id', room_id)
    return this.https.get<any>(this.Socket_endpoint + '/chat/group-info', { params });
  }

  get_all_group(): Observable<any> {
    return this.https.get<any>(this.Socket_endpoint + '/chat/all-groups');
  }

  get_all_group_new(scrollNumber, groupLength, room_id: string): Observable<any> {
    let params = new HttpParams();
    params = params.append('app_type', 'webapp');
    params = params.append('page', scrollNumber);
    params = params.append('total_groups', groupLength);
    params = params.append('room_id', room_id);
    return this.https.get<any>(this.Socket_endpoint + '/chat/all-groups', { params });
  }

  update_group(more_member, group_name, description, group_icon, room_id, delete_member): Observable<any> {
    let params = new HttpParams();
    let body;
    let userId = [];
    if (delete_member) {
      params = params.append('room_id', room_id)
    }

    body = {
      'more_users': more_member,
      "group_name": group_name,
      "group_description": description,
      "group_photo": group_icon,
      "room_id": room_id,
      "remove_users": [...delete_member]
    }



    return this.https.patch<any>(this.Socket_endpoint + '/chat/update-group-info', body, { params })
  }

  exit_group(room_id): Observable<any> {
    let body = {
      "room_id": room_id
    }
    return this.https.patch<any>(this.Socket_endpoint + '/chat/exit-group', body)
  }

  delete_group(room_id): Observable<any> {
    let params = new HttpParams();
    params = params.append("room_id", room_id)
    return this.https.delete<any>(this.Socket_endpoint + '/chat/delete-group', { params })
  }



  // LIVE SESSION SOCKET CONNECTION

  liveSessionConnection(course_id, topic_id, singleCoursetab = 1) {
    if (!this.sockets) return;
    if (singleCoursetab == 1) {
      if (course_id && topic_id) {
        this.sockets.emit('live_session_status', {
          "course_id": course_id,
          "topic_id": topic_id,
          "user_id": this.user_id
        });
      }
    } else if (singleCoursetab == 5) {
      if (course_id) {
        this.sockets.emit('live_session_status', {
          "course_id": course_id,
          "user_id": this.user_id
        });
      }
    }


  }

  receiveLiveSession() {
    if (!this.sockets) return;
    this.sockets.on('current_live_session_status', (data) => {
      if (data && data.user_id == this.user_id) {
        this.receiveStatus = [];
        this.receiveStatus = data.course_live_sessions;
        // console.log(data);
      } else {
        // console.log('Extra Soket else.');        
      }

      // if(data.course_id == localStorage.getItem('course_id')){
      // this.receiveStatus = [];
      // }
    });
  }

  // video_duration:number
  // admindata:any;
  // receiveLiveSessionForadmin() {
  //   // console.log("zoom outside")
  //   this.sockets.on('zoom_live_session_status_update', (data) => {
  //     if(data){
  //       if(data.course_id == localStorage.getItem('course_id')){
  //         this.video_status = [];
  //       this.admindata = data;
  //       console.log(data);

  //         this.video_status = data;
  //         this.video_duration = data.duration

  //       return  this.admindata;
  //       }
  //     }
  //   });

  // }

  receiveLiveSessionForadmin(): Observable<any> {
    return new Observable<any>((observer) => {
      if (!this.sockets) return;
      this.sockets.on('zoom_live_session_status_update', (data) => {
        observer.next(data);
      })
    })
  }


  get_notification_list = [];
  get_notification() {
    // let room_id = this.room_id
    let notification = [];
    let nofity = this.ns;
    this.sockets.on('send_notification', function (data) {
      notification.push(data)
      let is_Mute: boolean = data.is_mute;
      if (!is_Mute) {
        nofity.showNotification('success', data.sender_name + ' sent you a message.');
      }
      // if (notification.length % 10 == 0) {
      //   this.ns.showNotification('success', 'You have got some message from groups and chats');
      // }
    })
    this.get_notification_list = notification;
  }

  leave_room(room_id, user_id) {
    if (!this.sockets) return;
    this.sockets.emit('leave_room', {
      'room': room_id,
      'username': user_id
    });
  }

  acknowledgement(room_id, user_id, message_id) {
    if (!this.sockets) return;
    this.sockets.emit('message_acknowledgement', {
      'room': room_id,
      'username': user_id,
      'message_id': message_id
    });
  }

  disconnect() {
    if (this.sockets) {
      this.sockets.removeAllListeners();
      this.sockets.disconnect();
      this.sockets = null;
    }
    if (this.notifSocket) {
      this.notifSocket.removeAllListeners();
      this.notifSocket.disconnect();
      this.notifSocket = null;
    }
  }

  initialize_chat(project_name, admin_list, project_Des, project_id) {
    let body = {
      "group_name": project_name,
      "admins": admin_list,
      "group_description": project_Des,
      "subheading": "",
      "passion_project_id": project_id
    }
    return this.https.post<any>(this.APIEndpoint + '/init_mentor_chat', body)
  }

  get_passion_project_proposal(passion_project_id) {
    let params = new HttpParams();
    params = params.append('passion_project_id', passion_project_id);
    return this.https.get<any>(this.APIEndpoint + '/passion_project_proposal', { params })
  }

  listenGlobalMessageCount() {
    if (!this.sockets) return;
    this.sockets.off('global_message_count');
    this.sockets.on('global_message_count', (data) => {
      const unreadMessagesCount = Number(data && data.unread_messages_count);
      const individualUnreadMessagesCount = Number(data && data.individual_unread_messages_count);
      const groupUnreadMessagesCount = Number(data && data.group_unread_messages_count);
      const favouriteUnreadMessagesCount = Number(data && data.favourite_user_unread_messages_count);

      localStorage.setItem(this.globalMessageCountStorageKey, String(Number.isNaN(unreadMessagesCount) ? 0 : unreadMessagesCount));
      localStorage.setItem(this.individualUnreadMessageCountStorageKey, String(Number.isNaN(individualUnreadMessagesCount) ? 0 : individualUnreadMessagesCount));
      localStorage.setItem(this.groupUnreadMessageCountStorageKey, String(Number.isNaN(groupUnreadMessagesCount) ? 0 : groupUnreadMessagesCount));
      localStorage.setItem(this.favouriteUnreadMessageCountStorageKey, String(Number.isNaN(favouriteUnreadMessagesCount) ? 0 : favouriteUnreadMessagesCount));
    });
  }

  count_update = [];
  getCountAmount: any;
  get_count() {
    if (!this.sockets) return;
    let count_update = [];
    let $this = this;
    $this.sockets.on('send_chat_users', function (data) {
      let room_id = localStorage.getItem('room_id');


      this.getCountAmount = data;

      // if (room_id != data.room_id) {
      count_update = [];
      count_update.push(data);
      // }     
      $this.count_update = count_update;

      $this.shareService.setCountNumber(data.total_unread_messages);

    });
  }

}
